module.exports = __webpack_public_path__ + "img/qrcode1.7218d326.png";